
import { Component, ChangeDetectionStrategy, HostBinding } from '@angular/core';
import { CardComponent } from '@knorr-bremse-portals/ngx-components/components/card';
import { HtmlComponent } from '@knorr-bremse-portals/ngx-components/components/html';
import { iconBrakeshoeLeft } from '@knorr-bremse-portals/icons';
import { IconComponent } from '@knorr-bremse-portals/ngx-components/components/icon';
import { SectionComponent } from '../../../app/components/section/section.component';
import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { InnerSection, InnerSectionAttributes, Section, SectionAttributes } from '../../../app/types/section';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';

interface StickyHotlineItem extends InnerSectionAttributes {
  headline: string;
  email?: string;
  phone: string;
  hours?: string;
  legalInfo?: string;
  copyText?: string;
}

type StickyHotlineItemEditorIds = [];

type StickyHotlineItemSection = InnerSection<StickyHotlineItem, StickyHotlineItemEditorIds, 'sticky-hotline-item'>;

type StickyHotlineSection = Section<
  {
    headline: string;
    items: StickyHotlineItemSection[];
    opened?: boolean;
  } & SectionAttributes,
  [
    'headline',
    'items',
    'opened',
  ],
  'sticky-hotline'
>;

@Component({
  selector: 'app-sticky-hotline',
  templateUrl: './sticky-hotline.component.html',
  styleUrls: ['./sticky-hotline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    EditorIdDirective,
    CardComponent,
    HtmlComponent,
    IconComponent,
    FsButtonComponent,
],
})
export class StickyHotlineComponent extends SectionComponent<StickyHotlineSection> {

  protected iconButton = iconBrakeshoeLeft;
  @HostBinding('class.open') protected open = false;

}
